const AGREEMENT = {
  concorde: "Stessa indicazione", parziale: "Indica una causa alternativa", discorde: "Indicazione diversa",
  nessun_risultato: "Nessun riconoscimento", non_coperta: "Avversità non coperta", non_disponibile: "Non disponibile", in_corso: "In corso",
};

const Group = ({ title, children, testid }) => (
  <div className="border-t border-[#ddc69c]/60 pt-4" data-testid={testid}>
    <h3 className="mb-2 text-[19px] font-semibold text-[#0D2517]">{title}</h3>
    {children}
  </div>
);

const Bullets = ({ items }) => (
  <ul className="list-disc space-y-2 pl-5 text-[17px] leading-relaxed text-[#2D3A30]">{items.map((t, i) => <li key={i}>{t}</li>)}</ul>
);

const LegacyCare = ({ d }) => (
  <>
      {d.monitoring?.length > 0 && <Group title="Cosa controllare nei prossimi giorni" testid="details-monitoring"><Bullets items={d.monitoring} /></Group>}
      {d.prevention?.length > 0 && <Group title="Prevenzione" testid="details-prevention"><Bullets items={d.prevention} /></Group>}
      {d.avoid?.length > 0 && <Group title="Da evitare" testid="details-avoid"><Bullets items={d.avoid} /></Group>}
      {d.phyto?.verified_uses?.length > 0 && (
        <Group title="Impieghi verificati dalla professionista" testid="details-verified-uses">
          <Bullets items={d.phyto.verified_uses.map((u) => [u.active_substance, u.crop, u.limitations, u.source_name && `fonte: ${u.source_name}`, u.verified_at && `verificato il ${u.verified_at}`].filter(Boolean).join(" · "))} />
        </Group>
      )}
      {d.when_professional && <Group title="Quando chiedere un professionista" testid="details-professional"><p className="text-[17px] leading-relaxed text-[#2D3A30]">{d.when_professional}</p></Group>}
  </>
);

export default function ResultDetails({ result: r, pro = false, consultDone = false }) {
  const d = r.details || {};
  const pn = r.comparison?.plantnet_diseases;
  return (
    <div className="space-y-4 rounded-2xl border border-[#ddc69c]/70 bg-white p-5" data-testid="result-details">
      <h2 className="font-serif text-[22px] font-semibold leading-tight text-[#0D2517]">Diagnosi e valutazione</h2>
      {d.why && <Group title="Perché" testid="details-why"><p className="text-[17px] leading-relaxed text-[#2D3A30]">{d.why}</p></Group>}
      {d.observed?.length > 0 && (
        <Group title="Segni visti nelle foto" testid="details-observed">
          <Bullets items={d.observed.map((o) => `${o.text}${o.photos?.length ? ` (foto ${o.photos.join(", ")})` : ""}`)} />
        </Group>
      )}
      {r.status_reasons?.length > 0 && <Group title="Grado di attendibilità" testid="details-status"><Bullets items={r.status_reasons} /></Group>}
      {d.alternatives?.length > 0 && (
        <Group title="Altre cause considerate" testid="details-alternatives">
          <div className="space-y-3">
            {d.alternatives.map((a) => (
              <div key={a.id} className="rounded-xl bg-[#f8f3e9] p-3">
                <p className="text-[17px] font-semibold text-[#0D2517]">{a.name} <span className="botanical font-normal text-[#B39257]">{a.agent}</span></p>
                {a.for?.length > 0 && <p className="text-[16px] text-[#2D3A30]"><strong>A favore:</strong> {a.for.join("; ")}</p>}
                {a.against?.length > 0 && <p className="text-[16px] text-[#2D3A30]"><strong>Contro:</strong> {a.against.join("; ")}</p>}
              </div>
            ))}
          </div>
        </Group>
      )}
      {d.out_of_kb?.length > 0 && (
        <Group title="Ipotesi da far verificare a un professionista" testid="details-out-of-kb">
          <Bullets items={d.out_of_kb.map((o) => `${o.name}${o.rationale ? `: ${o.rationale}` : ""}`)} />
        </Group>
      )}
      {!consultDone && <LegacyCare d={d} />}
      {pro && r.evidence && (
        <Group title="Caratteri specifici e segni generici (solo area professionista)" testid="details-evidence">
          {r.evidence.specific_matched?.length > 0
            ? <Bullets items={r.evidence.specific_matched.map((x) => `[${x.code}] ${x.character} — visto: ${x.evidence}${x.photos?.length ? ` (foto ${x.photos.join(", ")})` : ""}`)} />
            : <p className="text-[17px] text-[#2D3A30]">Nessun carattere specifico riconosciuto.</p>}
          {r.evidence.generic_signs?.length > 0 && <p className="mt-2 text-[16px] text-[#5b6b60]"><strong>Segni generici:</strong> {r.evidence.generic_signs.join("; ")}</p>}
        </Group>
      )}
      {pro && pn && (
        <Group title="Confronto con Pl@ntNet Diseases (solo area professionista)" testid="details-plantnet">
          <p className="text-[17px] text-[#2D3A30]"><strong>{AGREEMENT[pn.agreement] || pn.agreement}.</strong> {pn.note}</p>
          {pn.top?.length > 0 && <Bullets items={pn.top.map((t) => `${t.kb_names?.join(" / ") || t.label} (${t.label})`)} />}
          <p className="mt-2 text-[15px] text-[#5b6b60]">Il confronto tra i due sistemi è un elemento di valutazione, non una conferma della diagnosi.</p>
        </Group>
      )}
    </div>
  );
}
